const { REACT_APP_ENV, REACT_APP_API_URL } = process.env;

let defaultConfig = {
    apiUrl: REACT_APP_API_URL,
    env: REACT_APP_ENV
}

let selectedConfig = {};

const config = {
    ...defaultConfig,
    ...selectedConfig,
}

export default config;
